<template>
  <div>
    <!-- #page-title end -->
    <div class="clear"></div>
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix row">
          <div class="d-none d-xl-block center" style="margin-left:auto; margin-right:auto;">
            <i class="icon-screen" style="font-size: 216px; line-height: 1; margin-bottom: 20px;"></i>

            <div class="alert alert-info nobottommargin">
              <strong>Note:</strong> This Text is visible only on Desktop Devices. Resize your Browser to view others
            </div>
          </div>

          <!-- Contact Form
          =============================================-->
          <div class="col-12">
            <!-- Contact Info
            =============================================-->

            <div class="row clear-bottommargin">
              <div class="col-5">
                <img
                  src="assets/icon/request.png"
                  style="width: 50%; margin: 0 0 0 auto;
							display: block;"
                />
              </div>
              <div class="col-6 adminword">
                ติดตามชุดสวยอัพเดตใหม่ และสอบถามรายละเอียด
                <br />แอดมินของเรายินดีให้บริการ
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-phone3"></i>
                    </a>
                  </div>
                  <h3>
                    Line
                    <span class="subtitle">@alexrental.app</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-skype2"></i>
                    </a>
                  </div>
                  <h3>
                    Facebook
                    <span class="subtitle">facebook.com/alexrentalapp</span>
                  </h3>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 bottommargin clearfix">
                <div class="feature-box fbox-center fbox-bg fbox-plain">
                  <div class="fbox-icon">
                    <a href="#">
                      <i class="icon-twitter2"></i>
                    </a>
                  </div>
                  <h3>
                    Follow on instragram
                    <span class="subtitle">Instagram.com/alexrental.app</span>
                  </h3>
                </div>
              </div>
            </div>
            <!-- Contact Info End -->
          </div>
          <!-- Contact Form End -->
        </div>

        <div class="container clearfix">
          <div class="fancy-title title-dotted-border" style="margin-top: 20px;">
            <h3>สาขาลาดพร้าว</h3>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6" style="font-size: 20px;">
                <u>เปิดบริการ</u>
                <br />11.00 - 20.00 น.
                <br />ทุกวันอังคาร - วันอาทิตย์ (หยุดวันนัขตฤกษ์)
                <br />โทร. 097-210-1000
                <br />
                <u>Google Map</u>
                <a href="https://bit.ly/2Mof6AW">https://bit.ly/2Mof6AW</a>
              </div>
              <div class="col-6">
                <u>รูปแผนที่</u>
                <img src="assets/map/Lat Prow.jpg" width="70%" />
              </div>
            </div>
          </div>
        </div>

        <!-- Google Map
        =============================================-->
        <!-- <div class="col-12 col_last">

						<section id="google-map" class="gmap" style="height: 410px;">
						
						</section>

        </div>-->
        <!-- Google Map End -->

        <div class="container clearfix">
          <div class="fancy-title title-dotted-border">
            <h3>สาขาเมืองทอง</h3>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-6" style="font-size: 20px;">
                <u>เปิดบริการ</u>
                <br />11.00 - 20.00 น.
                <br />ทุกวันอังคาร - วันอาทิตย์ (หยุดวันนัขตฤกษ์)
                <br />โทร. 097-210-1000
                <br />
                <u>Google Map</u>
                <a href="https://bit.ly/2Mof6AW">https://bit.ly/2Mof6AW</a>
              </div>
              <div class="col-6">
                <img src="assets/map/MaeungThong.jpg" width="70%" />
              </div>
            </div>
          </div>
        </div>

        <!-- Google Map
        =============================================-->
        <!-- <div class="col-12 col_last">

							<section id="google-map" class="gmap" style="height: 410px;">
							
							</section>
	
        </div>-->
        <!-- Google Map End -->
      </div>
      <div class="clear"></div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
// import store from "@/store.js";
export default {
  props: ["msg"],
  data() {
    return {
      welcome: "This is your profile"
    };
  },
  methods: {
    welcomeMessage() {}
  },
  components: {}
};
</script>
 
<style >
</style>